import { FC } from 'react';
import { Link } from 'react-router-dom';

import Badge from 'primitives/Badge';

import statusEnumToReadable from 'utils/enums/status-enum-to-readable';

const IN_ESCROW_STATUS = 'IN_ESCROW';

// The panel sits flush under the badge (no gap) so the pointer can travel onto the link.
const DematUnitStatusBadge: FC<{
  isinStatus?: string | null;
  investmentEntityId: string;
}> = ({ isinStatus, investmentEntityId }) => {
  if (!isinStatus) return null;

  const { label, color } = statusEnumToReadable(isinStatus);
  const badge = <Badge label={label} color={color} showIndicator={true} />;

  if (isinStatus !== IN_ESCROW_STATUS) return badge;

  return (
    <span className="group relative inline-flex" onClick={event => event.stopPropagation()}>
      <span tabIndex={0} className="inline-flex cursor-help rounded focus:outline-none">
        {badge}
      </span>
      <span
        role="tooltip"
        className="invisible absolute left-0 top-full z-50 w-64 pt-2 text-left group-hover:visible group-focus-within:visible"
      >
        <span className="block rounded bg-gray-900 p-3 text-xs font-normal text-white shadow-lg">
          Your units are held in escrow. Fill in your demat details to receive the units in your
          demat account.
          <Link
            to={`/invest/investment-entities/${investmentEntityId}/demat`}
            className="mt-2 block font-medium text-indigo-300 underline hover:text-indigo-200"
          >
            Add demat details
          </Link>
        </span>
      </span>
    </span>
  );
};

export default DematUnitStatusBadge;
